// extracted by mini-css-extract-plugin
export default {"hero":"styles_hero__bepnw","heroContent":"styles_heroContent__8Yl1K","heroForm":"styles_heroForm__6XPcM"};